import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Label, Row } from "reactstrap"
import { useDispatch } from "react-redux"
import { saveSourceFinancing as onSaveSourceFinancing } from "../../store/Config/actions"

const FormSourceFinancing = ({sourceFinancingList}) => {

    const dispatch = useDispatch()


    const sFinancing = [
        { id: 1, name: "Recursos Fiscales", bank:"",account_number:"" },
        { id: 2, name: "Ramo 28", bank:"",account_number:"" },
        { id: 3, name: "Ramo 33 Fondo IV", bank:"",account_number:"" },
        { id: 4, name: "Ramo 33 Fondo III", bank:"",account_number:"" },
        { id: 5, name: "Convenios Federelaes", bank:"",account_number:"" },
      ]

    const [sourceFinancing, setSourceFinancing] = useState([])


    const   handleSourceFinSave = () => {
      dispatch(onSaveSourceFinancing({sourceFinancingList:sourceFinancing}))
    }

    const handleAddSource = () => {
      setSourceFinancing((prev) => {
        const current = Array.isArray(prev) ? prev : []
        const maxId = current.reduce((acc, item) => {
          const value = typeof item?.id === "number" ? item.id : 0
          return Math.max(acc, value)
        }, 0)

        return [
          ...current,
          { id: maxId + 1, name: "", bank: "", account_number: "", isCustom: true },
        ]
      })
    }

    const handleValueFinancing = (e, key) => {
      const sFList = [...sourceFinancing]
      const source = sFList[key];
      source[e.target.name] = e.target.value;
      sFList.splice(key,1,source)
      setSourceFinancing(sFList)
    }

    useEffect(()=>{
      const list = Array.isArray(sourceFinancingList) ? sourceFinancingList : []
      setSourceFinancing(list.length > 0 ? list : sFinancing)
    },[sourceFinancingList])

    return (
        <>
        <Form onSubmit={(e)=>{
            e.preventDefault();
            handleSourceFinSave()
           
        }}>
            <Card>
                <CardBody>
                  <CardTitle>Catálogo de Fuentes de Financiamiento </CardTitle>
                  <p className="card-title-desc">
                    Información de bancos y cuentas
                  </p>
                    {
                      
                      sourceFinancing.map((item, key) => {return (
                      <Row key={item?.id ?? key}>
                      <Col sm={6}>
                        <div className="mb-3">
                          <Label htmlFor={`name-${item?.id ?? key}`}>Fuente</Label>
                          <Input
                            id={`name-${item?.id ?? key}`}
                            name="name"
                            value={item.name}
                            disabled={!item.isCustom && item.name?.length > 0}
                            onChange={(e)=>handleValueFinancing(e, key)}
                            type="text"
                            className="form-control"
                            placeholder=""
                          />
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="mb-3">
                          <Label  htmlFor={`bank-${item?.id ?? key}`}>
                            Banco
                          </Label>
                          <Input
                            className="form-control"
                            id={`bank-${item?.id ?? key}`}
                            value={item.bank}
                            name="bank" onChange={(e)=>handleValueFinancing(e, key)}
                            placeholder=""
                          />
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="mb-3">
                          <Label htmlFor={`account_number-${item?.id ?? key}`}>
                            Número de Cuenta
                          </Label>
                          <Input
                            className="form-control"
                            id={`account_number-${item?.id ?? key}`}
                            value={item.account_number}
                            name="account_number" onChange={(e)=>handleValueFinancing(e, key)}
                            placeholder=""
                          />
                        </div>
                      </Col>
                    </Row>
                    )})
                    }

                    <Row >
                      <Col sm={12}>
                        <div className="mb-3 text-end">
                           <Button id="btnAddSource" type="button" className="btn btn-info waves-effect waves-light" color="primary" onClick={handleAddSource}>
                            Agregar Fuente
                          </Button>
                        </div>
                      </Col>
                      
                    </Row>
                    
                    <div className="text-end" >
                      <Button type="submit" className="btn btn-primary waves-effect waves-light" color="primary">
                        Guardar Cambios
                      </Button>
                    </div>
                </CardBody>
              </Card>
        </Form>
        </>
    )
}

export default FormSourceFinancing
